module.exports = __webpack_public_path__ + "static/media/55.263042f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/55.jpg
// module id = 616
// module chunks = 0